import { MAX_LENGTH_PHONE_NUMBER } from "@/services/constants/validateSchema";
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Stack,
  Text,
} from "@chakra-ui/react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
// Refer PhoneInput.js
// Bad naming
export default function PhoneInputFormWithKoreanFormat({
  name = "phone",
  // No default value
  value,
  setValue,
  error,
  touched,
  // No rest
}) {
  const { t } = useTranslation();

  const formating = (input) => {
    let output;
    const rawValue = input.replaceAll("-", "");

    if (rawValue.length >= 8) {
      output =
        rawValue.substring(0, 3) +
        "-" +
        rawValue.substring(3, 7) +
        "-" +
        rawValue.substring(7, 11);
      if (rawValue.length > 11) {
        output = output + "-" + rawValue.substring(11);
      }
    }
    if (rawValue.length < 8 && rawValue.length >= 4) {
      output = rawValue.substring(0, 3) + "-" + rawValue.substring(3);
    }

    return output;
  };

  const onChange = (value) => {
    const formattedValue = formating(value);
    // Zero reusability outside formik
    setValue(name, formattedValue);
  };

  useEffect(() => {
    if (value) {
      const formattedValue = formating(value);
      setValue(name, formattedValue);
    }
  }, [value, name, setValue]);

  return (
    // FormControl reduces reusability, what if the input is not required? More props? How many props should be added?
    <FormControl isInvalid={error && touched} isRequired>
      <Stack direction="row">
        <FormLabel htmlFor={name}>{t("Phone number")}</FormLabel>
        <Text>{t("Identity verification")}</Text>
      </Stack>
      <Input
        id={name}
        name={name}
        type="text"
        placeholder={t("xxx-xxxx-xxxx")}
        value={value}
        maxLength={MAX_LENGTH_PHONE_NUMBER}
        onChange={(event) => onChange(event.target.value)}
      />
      <FormErrorMessage>{t(error)}</FormErrorMessage>
    </FormControl>
  );
}
